export const normEmail = (e) => (e || "").trim().toLowerCase();
export const emailKey = (e) => normEmail(e).replace(/\./g, ","); // for RTDB keys
export const threadKeyFromTwo = (a,b) => {
  const [p0, p1] = [normEmail(a), normEmail(b)].sort();
  return `${p0}||${p1}`;
};
